var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 69,
    viewBox: "0 0 78 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2158 32.1412C38.5921 31.3413 39.7452 31.3873 40.0566 32.2147L42.5685 38.8893C42.7051 39.2522 43.0391 39.5034 43.4256 39.534L51.115 40.1422C52 40.2122 52.3618 41.3149 51.6901 41.8955L45.9343 46.8717C45.6491 47.1184 45.5268 47.5045 45.6181 47.8704L47.5455 55.5934C47.7635 56.4667 46.807 57.1609 46.0443 56.6829L39.3211 52.47C38.9896 52.2623 38.5673 52.267 38.2405 52.482L31.9941 56.5918C31.2332 57.0925 30.2536 56.398 30.4742 55.5143L32.3756 47.8956C32.4702 47.5167 32.3355 47.1173 32.0307 46.8731L26.3284 42.3038C25.6412 41.7531 25.9497 40.6473 26.8228 40.532L34.2201 39.5554C34.5575 39.5108 34.8491 39.2977 34.994 38.9896L38.2158 32.1412Z",
    stroke: "white",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.8662,
    y: 2,
    width: 9.25352,
    height: 12.6757,
    rx: 1,
    stroke: "white",
    strokeWidth: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8799,
    y: 2,
    width: 9.25352,
    height: 12.6757,
    rx: 1,
    stroke: "white",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6479 6.33789H70.5C73.2614 6.33789 75.5 8.57647 75.5 11.3379V62C75.5 64.7615 73.2614 67.0001 70.5 67.0001H7.5C4.73857 67.0001 2.5 64.7615 2.5 62.0001V20.3717V11.3379C2.5 8.57647 4.73858 6.33789 7.5 6.33789H15.8662M52.8803 6.33789H25.1197",
    stroke: "white",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.7297H74.9859",
    stroke: "white",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.0d24a86c910bc40c3542c289d704df1d.svg";
export { ForwardRef as ReactComponent };